export const UPDATE_SETTING_STATE = 'UPDATE_SETTING_STATE';
export const DELETE_SETTING_STATE = 'DELETE_SETTING_STATE';
export const TEAM_MEMBERS_LOADING = 'TEAM_MEMBERS_LOADING';
export const TEAM_MEMBERS_LOADED = 'TEAM_MEMBERS_LOADED';
export const TEAM_MEMBERS_LOAD_ERROR = 'TEAM_MEMBERS_LOAD_ERROR';
export const NEW_MEMBERS_ADDING = 'NEW_MEMBERS_ADDING';
export const NEW_MEMBERS_ADDED = 'NEW_MEMBERS_ADDED';
export const NEW_MEMBERS_ADDITION_ERROR = 'NEW_MEMBERS_ADDITION_ERROR';
export const REPLACE_MEMBER_OBJECT_IN_TEAM_MEMBERS = 'REPLACE_MEMBER_OBJECT_IN_TEAM_MEMBERS';
export const USER_PERMISSIONS_LOADING = 'USER_PERMISSIONS_LOADING';
export const USER_PERMISSIONS_LOADED = 'USER_PERMISSIONS_LOADED';
export const USER_PERMISSIONS_LOAD_ERROR = 'USER_PERMISSIONS_LOAD_ERROR';
export const USER_PERMISSIONS_UPDATING = 'USER_PERMISSIONS_UPDATING';
export const USER_PERMISSIONS_UPDATION_COMPLETE = 'USER_PERMISSIONS_UPDATION_COMPLETE';



// WEBPACK FOOTER //
// ./src/data/redux/team_member_setting_details/actiontypes.js